import React, { useEffect, useRef, useState } from 'react';

const withResponsiveCheck = WrappedComponent => {
  return props => {
    const targetRef = useRef(null);
    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
      const resizeObserver = new ResizeObserver(handleResize);

      const currentRef = targetRef.current;

      if (currentRef) {
        resizeObserver.observe(currentRef);
      }

      return () => {
        if (currentRef) {
          resizeObserver.unobserve(currentRef);
          resizeObserver.disconnect();
        }
      };
    }, []); // No dependency array since we are not using any external variables

    const handleResize = entries => {
      for (const entry of entries) {
        if (entry && entry.contentRect && entry.contentRect.width <= 599) {
          setIsMobileView(true);
        } else {
          setIsMobileView(false);
        }
      }
    };

    return (
      <div ref={targetRef}>
        <WrappedComponent {...props} isMobileView={isMobileView} />
      </div>
    );
  };
};

export default withResponsiveCheck;
